import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { isAutorisationPopupOpenSelector, isConsultantChatOpenedSelector } from '../../../selectors/consultantChat';

import { getChatOnboardingCookie, setChatOnboardingCookie } from '../utils/chatOnboardingCookie';
import { useApplicationContext } from '../../../utils/applicationContext';

interface IOnboardingTooltipResult {
  open: boolean;
  closeHandler: () => void;
}

const COOKIE_NAME = 'newbuilding-card-desktop-frontend.consultant_cian_chat_onboarding_shown';

export const useChatOnboarding = (): IOnboardingTooltipResult => {
  const { config } = useApplicationContext();

  const [open, setOpen] = useState(false);

  const isConsultantChatOpen = useSelector(isConsultantChatOpenedSelector);
  const isConsultantAuthorizationPopupChatOpen = useSelector(isAutorisationPopupOpenSelector);

  const closeHandler = useCallback(() => {
    setOpen(false);
  }, []);

  useEffect(() => {
    if (!getChatOnboardingCookie(COOKIE_NAME)) {
      setOpen(true);
      setChatOnboardingCookie(COOKIE_NAME);
    }
  }, [config]);

  useEffect(() => {
    if ((open && isConsultantChatOpen) || (open && isConsultantAuthorizationPopupChatOpen)) {
      closeHandler();
    }
  }, [closeHandler, isConsultantAuthorizationPopupChatOpen, isConsultantChatOpen, open]);

  return {
    open,
    closeHandler,
  };
};
